import './OnlineUsers.css'; // Assuming you have appropriate CSS for styling

const OnlineUsers = ({ allUsers }) => {
  if (!allUsers) return <div>No users available</div>;

  return (
    <div className="online-users">
      <h3>Online Users</h3>
      {allUsers.length === 0 ? (
        <p>Loading...</p>
      ) : (
        <ul>
          {allUsers.map(user => (
            <li key={user.userId}>
              <div className="status-indicator" />
              <img
                src={user.profilePicture}
                alt={`${user.name}'s profile`}
                className="profileImage"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = '/default-profile.png'; // fallback image
                }}
              />
              <span>{user.name || 'No Name'}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default OnlineUsers;
